import { Section } from "../tools/section";
import { initCollageImageVideo } from "../animations/sections/collage-image-video";

// Selectors
const SELECTOR_SECTION = '[data-collage-image-video]';

export class CollageImageVideo extends Section {
  queryChildren(container: HTMLElement) {
  }

  attachEvents() {
    initCollageImageVideo();
  }

  detatchEvents() {
  }
}

Section.register(SELECTOR_SECTION, CollageImageVideo);
